import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const UserManagementTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [users, setUsers] = useState([]);
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API_BASE()}/active-users?days=${days}`, { headers })
      .then((r) => r.json())
      .then((data) => data.success && setUsers(data.users || []))
      .finally(() => setLoading(false));
  }, [days]);

  if (loading) return <div className="loading-message">Loading...</div>;
  return (
    <div className="tab-content">
      <p>Users who have downloaded Word documents (login-required). For full user CRUD use User Management.</p>
      <div style={{ marginBottom: 16 }}>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))}>
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
      </div>
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Downloads</th>
              <th>Last download</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.email}</td>
                <td>{(u.first_name || '') + ' ' + (u.last_name || '')}</td>
                <td>{u.download_count ?? 0}</td>
                <td>{u.last_download ? new Date(u.last_download).toLocaleDateString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!users.length && <p style={{ padding: 16 }}>No users in this period.</p>}
      </div>
    </div>
  );
};

export default UserManagementTab;
